import { useTranslation } from 'react-i18next'
import Skeleton from 'react-loading-skeleton'
import { isFunction } from 'remeda'
import { useTheme } from 'styled-components'
import { EmptyStar } from '@velasca/icons/empty-star'
import { FullStar } from '@velasca/icons/full-star'
import { HalfStar } from '@velasca/icons/half-star'
import { Badge, Label, SkeletonStarIcon } from './ReviewBadge.styles'
import type { ReviewBadgeProps } from './ReviewBadge.types'

export const ReviewBadge = ({
  reviewsCount = 0,
  reviewsAverage = 0,
  className = '',
  loading = false,
  onClick,
  short = false,
  starSize = 20,
}: ReviewBadgeProps): JSX.Element => {
  const theme = useTheme()
  const { t } = useTranslation('global')

  return (
    <Badge
      className={className}
      onClick={isFunction(onClick) ? onClick : undefined}
    >
      {loading ? (
        <>
          <Skeleton count={5} wrapper={SkeletonStarIcon} height="100%" />
          <Skeleton
            style={{ marginLeft: '0.8rem' }}
            width="12rem"
            height="1.5rem"
          />
        </>
      ) : (
        [1, 2, 3, 4, 5].map((indexValue) => {
          const result = Number(reviewsAverage ?? 0) - indexValue

          if (result > -0.2) {
            return (
              <FullStar
                color={theme.colors.primary}
                width={starSize}
                height={starSize}
                key={indexValue}
              />
            )
          }

          if (result < 0 && result >= -0.5) {
            return (
              <HalfStar
                color={theme.colors.primary}
                width={starSize}
                height={starSize}
                key={indexValue}
              />
            )
          }

          return (
            <EmptyStar
              color={theme.colors.primary}
              width={starSize}
              height={starSize}
              key={indexValue}
            />
          )
        })
      )}
      {!loading && (
        <Label>
          {short
            ? Number(reviewsCount)
            : t('reviews_label', {
                count: Number(reviewsCount),
              })}
        </Label>
      )}
    </Badge>
  )
}
